import React, { useMemo } from 'react';
import { View, Text, StyleSheet, Pressable, ImageBackground, ScrollView, Dimensions, Image } from 'react-native';
import { Spacing, Mixins, Typography, Colors } from '@styles';
import { useTheme } from '@themeProvider';
import { useLanguage } from '@languageProvider';
import { Button, GeneralTag, BaseAvatar } from '@atoms';
import { parsePrice } from '@utils/helpers';
import { SmartFlatGridView, SmartWrapView } from '@lib';
import { Promotion, ProductNode, SelectionTree, Coupon } from '@datamodel';

export {
    ProductNodeCard,
    ProductItemCard,
    FungibleCard
} from './FungibleCard';

export {
    ProductPackCard
} from './ProductPackCard';

export const SelectedProductInfo = ({ product, selectionTree, style, ...props }) => {
    const { useColor } = useTheme();
    const [body, title, primary] = useColor(['body', 'title', ['primary', { isText: true }]]);
    const mainNode = ProductNode.getTreeNodes(product, [selectionTree._mainSelection])[selectionTree._mainSelection];
    const leafs = SelectionTree.getMarkedLeafs(selectionTree).map(l => l.name).filter(n => n !== mainNode.name);

    return <Pressable style={[Mixins.HORIZONTAL, { alignItems: leafs.length > 0 ? 'flex-start' : 'center', paddingHorizontal: Spacing.M }, style]} {...props}>
        <Image style={[Mixins.rounding(44), { height: 44, width: 44 }]} source={{ uri: mainNode?.photo }} />
        <View style={{ marginHorizontal: Spacing.XS, flex: 1 }}>
            <View style={[Mixins.HORIZONTAL, { justifyContent: 'space-between', alignItems: 'center' }]}>
                <Text style={[Typography.SUBTITLE, { color: title, flex: 1, overflow: 'hidden' }]}>{mainNode.name}</Text>
                {/* <Text style={[Typography.SUBTITLE, { color: primary }]}>{parsePrice(SelectionTree.calculatePrice(selectionTree), '€')}</Text> */}
            </View>
            {leafs.length > 0 &&
                <Text style={[Typography.BODY, { color: body }]}>{leafs.join(' · ')}</Text>
            }
        </View>
    </Pressable>
}
